module.exports = __webpack_public_path__ + "static/media/google-chat.d2ade1f7.svg";